<template>
    <div class="column is-12">
        <div class="columns">
            <div class="column">
                <span class="label edit-box__includes-inline-input">
                    {{ $t("attributes.title") }}

                    <a class="edit-button" @click="toggleAttributesModal">
                        <i aria-hidden="true" class="fa fa-pencil-square-o fa-lg" />
                    </a>
                </span>
            </div>

            <Attributes
                v-if="showAttributesModal"
                :all-attributes="allAttributes"
                :active-attributes="activeAttributes"
                @toggle-modal="toggleAttributesModal"
                @save="saveAttributes"
            />
        </div>

        <div v-if="activeAttributes.length > 0" class="columns">
            <div class="column">
                <ul class="attribute-list">
                    <li
                        :key="attribute.id"
                        v-for="attribute in activeAttributes"
                        class="attribute-item"
                    >
                        <i class="fa fa-check-circle is-valid" aria-hidden="true" />
                        {{ attribute.name }}
                    </li>
                </ul>
            </div>
        </div>

        <hr>
        <h3 style="margin-top: .5rem;">{{ $t("campsites.top3Attributes") }}</h3>
        <div class="columns is-4">
            <div
                class="column is-4"
                v-for="(field, idx) in ['top1_attribute', 'top2_attribute', 'top3_attribute']"
                :key="field"
            >
                <div class="edit-box__section">
                    <label :for="field" class="label"> Top {{ idx + 1 }} </label>
                    <ValidationProvider :name="field" :ref="field" v-slot="{ errors }">
                        <div class="select-with-icon">
                            <span class="select">
                                <select
                                    :id="field"
                                    v-model="settings[field]"
                                    :class="{ 'is-danger': errors[0] }"
                                    :name="field"
                                >
                                    <option :value="null">-</option>
                                    <option
                                        v-for="(item, id) in getTopXAttributes()"
                                        :key="item.id"
                                        :value="item.id"
                                    >
                                        {{ item.name }}
                                    </option>
                                </select>
                            </span>
                            <span
                                v-if="topXById(settings[field]) && topXById(settings[field]).icon_svg"
                                class="icon-preview"
                                v-html="topXById(settings[field]).icon_svg"
                            />
                        </div>
                        <span v-show="errors[0]" class="help is-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>
        <!-- -->
    </div>
</template>

<script>
import Attributes from '../../attributes';
import { Api } from '../../../../api';
import { EventBus } from '../../../../utils';
import { AppModel } from '../../../../models';

export default {
    name: 'AttributesTab',
    components: { Attributes },
    inject: ['settingsParent'],
    data() {
        return {
            showAttributesModal: false,
            allAttributes: [],
            attributeCategories: []
        };
    },
    async created() {
        this.attributeCategories = (await Api.attributes.getActiveCampsites()).data;
        this.allAttributes = (await Api.attributes.getAllCampsites()).data;
    },
    computed: {
        activeAttributes() {
            if(this.attributeCategories && this.attributeCategories.length >= 0) {
                return this.attributeCategories.map(c => c.attributes).flat();
            }
            return [];
        },
        sp() {
            return this.settingsParent;
        },
        settings() {
            return (this.sp && this.sp.value) || {};
        }
    },
    methods: {
        toggleAttributesModal() {
            this.showAttributesModal = !this.showAttributesModal;
        },
        getTopXAttributes() {
            return AppModel.topXAttributes;
        },
        topXById(id) {
            if(!id) return null;
            const list = this.getTopXAttributes() || [];
            return list.find(a => a.id === id) || null;
        },
        async saveAttributes(attributes) {
            const updatedAttributes = (await Api.attributes.setCampsites(attributes)).data;
            this.toggleAttributesModal();
            this.attributeCategories = updatedAttributes;
            EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                title: `<h3>${this.$t('generic.saveSuccessHeadline')}</h3>`,
                direction: 'Up',
                body: this.$t('generic.saveSuccess')
            });
        }
    }
};
</script>

<style scoped lang="scss">
.attribute-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
}

.attribute-item {
    display: flex;
    align-items: center;
    gap: 0.15rem;
    flex-basis: 32%;
}

.select-with-icon {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

/* Vue2 scoped deep selector: use >>> to reach slotted SVG */
.icon-preview >>> svg {
    width: 20px;
    height: 20px;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/components/campground-settings/tabs/AttributesTab.vue